import { Form } from "antd";
import { useField } from "formik";

function Input({ name, icon, setFieldValue, button, ...rest }) {
  const [field, meta] = useField(name);
  const config = { ...field, ...rest };

  if (meta && meta.touched && meta.error) {
    config.error = true;
    config.helperText = meta.error;
  }

  return (
    <Form.Item
      className="mb-0"
      label={rest?.label}
      help={meta.error && meta?.error && meta?.touched ? meta.error : ""}
      validateStatus={config.error ? "error" : "success"}
    >
      <input type="text" {...field} {...rest} />
      {icon}
      {button}
    </Form.Item>
  );
}

export default Input;
